import { endpoint } from "./index";
export const appurl = (value) => {
  return process.env.REACT_APP_BASE_URL + "/api/" + endpoint[value];
};

//return process.env.REACT_APP_BASE_URL+'/api/'+appendpoint.website+'/'+endpoint[value];
